export default __webpack_public_path__ + "static/ProValue_1@992-22228da0ba6551fd27dc24e904944284.png";